import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from "react-router";
import App from './App';
import ComingSoon from './ComingSoon';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {/* <ComingSoon /> */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
